import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl} from "../Univ";
function AdminDisputes() {
    const [disputes, setDisputes] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchDisputes();
    }, []);
    const fetchDisputes = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                baseUrl + "dispute/"
            );
            setDisputes(res.data);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };
    const resolveDispute = async (dispute) => {
        const result = await Swal.fire({
            title: "Resolution",
            input: "textarea",
            inputLabel: "Enter Resolution",
            showCancelButton: true
        });
        if (!result.value) return;
        try {
            await axios.patch(
                baseUrl +
                "update-dispute/" +
                dispute.id +
                "/",
                {
                    status: "RESOLVED",
                    resolution: result.value
                }
            );
            Swal.fire(
                "Success",
                "Dispute Resolved",
                "success"
            );
            fetchDisputes();
        } catch (err) {
            console.log(err);
            Swal.fire(
                "Error",
                "Unable to resolve dispute",
                "error"
            );
        }
    };
    const deleteDispute = async (id) => {
        const result = await Swal.fire({
            title: "Delete Dispute?",
            text: "This action cannot be undone",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete"
        });
        if (!result.isConfirmed) return;
        try {
            await axios.delete(
                baseUrl +
                "delete-dispute/" +
                id +
                "/"
            );
            Swal.fire(
                "Deleted",
                "Dispute Removed",
                "success"
            );
            fetchDisputes();
        } catch (err) {
            console.log(err);
            Swal.fire(
                "Error",
                "Unable to delete dispute",
                "error"
            );
        }
    };
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 50
        },
        {
            field: "title",
            headerName: "Title",
            flex: 1,
            minWidth: 180
        },
        {
            field: "raised_by",
            headerName: "Raised By",
            width: 100
        },
        {
            field: "description",
            headerName: "Description",
            flex: 2,
            minWidth: 250
        },
        {
            field: "status",
            headerName: "Status",
            width: 120
        },
        {
            field: "resolution",
            headerName: "Resolution",
            flex: 1,
            minWidth: 200,
            renderCell: (params) =>
                params.row?.resolution || "Pending"
        },
        {
            field: "assignment",
            headerName: "Crop type",
            width: 130,
            renderCell: (params) =>
                params.row?.assignment?.requirement?.crop_type || "-"
        },
        {
            field: "owner",
            headerName: "Owner",
            width: 100,
            renderCell: (params) =>
                params.row?.assignment?.requirement?.owner.name || "-"
        },
        {
            field: "worker",
            headerName: "Worker",
            width: 100,
            renderCell: (params) =>
                params.row?.assignment?.worker?.name || "-"
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 200,
            renderCell: (params) => (
                <div
                    style={{
                        display: "flex",
                        gap: "8px",
                        marginTop: "6px"
                    }}
                >

                    {params.row.status === "OPEN" && (
                        <button
                            className="btn btn-success btn-sm"
                            onClick={() =>
                                resolveDispute(params.row)
                            }
                        >
                            Resolve
                        </button>
                    )}

                    <button
                        className="btn btn-danger btn-sm"
                        onClick={() =>
                            deleteDispute(params.row.id)
                        }
                    >
                        Delete
                    </button>

                </div>
            )
        }
    ];
    return (
        <section className="container-fluid mt-4">

            <div className="page-header mb-4">

                <h3>
                    Admin Dispute Management
                </h3>

                <small>
                    View, Resolve and Delete Worker Disputes
                </small>

            </div>

            <div
                className="card shadow-sm border-0"
            >

                <div className="card-body">

                    <ERPDataGrid
                        sx={{
                            boxShadow: 4,
                            border: 4,
                            borderColor: 'primary.light',
                            '& .MuiDataGrid-cell:hover': {
                                color: 'primary.main',
                            },
                        }}
                        className="mt-4"

                        rows={disputes}
                        columns={columns}
                        loading={loading}
                        autoHeight
                        pageSizeOptions={[
                            10,
                            25,
                            50,
                            100
                        ]}

                        autoHeight
                    />

                </div>

            </div>

        </section>
    );
}
export default AdminDisputes;